import { FC } from 'react';
import Lottie from 'lottie-react';
import confettiAnimation from './confetti_2.json';
import { useStyles } from './styles';

const ConfettiAnimation: FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.confettiContainer}>
      <Lottie
        animationData={confettiAnimation}
        loop={false}
        autoplay={true}
        style={{ top: 0, left: 0, width: '100%', height: '50%' }}
      />
    </div>
  );
};

export default ConfettiAnimation;
